const STATUS_COLORS = {
  ACTIVE: 'bg-green-100 text-green-800',
  TRIALING: 'bg-blue-100 text-blue-800',
  PAST_DUE: 'bg-yellow-100 text-yellow-800',
  CANCELED: 'bg-red-100 text-red-800',
  EXPIRED: 'bg-gray-100 text-gray-800',
  SIGNED_UP: 'bg-blue-100 text-blue-800',
  CONNECTED: 'bg-cyan-100 text-cyan-800',
  GOOD_CUSTOMER: 'bg-purple-100 text-purple-800',
  CHURNED: 'bg-red-100 text-red-800',
  DELETED: 'bg-red-100 text-red-800',
  IN_PROGRESS: 'bg-yellow-100 text-yellow-800',
};

export default function StatusBadge({ status, value }) {
  const s = status || value;
  const color = STATUS_COLORS[s] || 'bg-gray-100 text-gray-800';
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${color}`}>{s}</span>;
}
